import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const opal = defineConnector({
  identifier: "opal",
  name: "Opal",
  tagLine: "Access management and approvals",
  logo,
  protocol: "http",
  tags: ["identity", "it"],
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create an Opal API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Opal, create an API token from your admin or developer settings and use it as a bearer token for API requests.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.opal.dev/v1/users",
  },
  defaultUrlPattern: () => "https://api\\.opal\\.dev/.*",
});
